var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});

// src/types/index.ts
var RESERVED_ENV_KEYS = /* @__PURE__ */ new Set([
  "PORT",
  "API_URL",
  "DATABASE_URL",
  "NODE_OPTIONS",
  "LD_PRELOAD",
  "LD_LIBRARY_PATH",
  "PATH",
  "HOME",
  "USER",
  "SHELL",
  "NODE_ENV",
  "NODE_PATH"
]);

// src/utils/index.ts
function generateId() {
  const crypto = __require("crypto");
  return crypto.randomBytes(8).toString("hex") + Date.now().toString(36);
}
function generateCuid() {
  const crypto = __require("crypto");
  const timestamp = Date.now().toString(36);
  const randomPart = crypto.randomBytes(6).toString("base64url").slice(0, 10);
  return `c${timestamp}${randomPart}`.slice(0, 25);
}
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
async function retry(fn, options = {}) {
  const { maxAttempts = 3, initialDelay = 1e3, maxDelay = 1e4 } = options;
  let lastError;
  let delay = initialDelay;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error instanceof Error ? error : new Error(String(error));
      if (attempt === maxAttempts) {
        break;
      }
      await sleep(delay);
      delay = Math.min(delay * 2, maxDelay);
    }
  }
  throw lastError;
}
function isValidGitUrl(url) {
  const gitUrlPatterns = [
    /^https:\/\/github\.com\/[\w-]+\/[\w.-]+(?:\.git)?$/,
    /^git@github\.com:[\w-]+\/[\w.-]+(?:\.git)?$/,
    /^https:\/\/gitlab\.com\/[\w-]+\/[\w.-]+(?:\.git)?$/,
    /^https:\/\/bitbucket\.org\/[\w-]+\/[\w.-]+(?:\.git)?$/
  ];
  return gitUrlPatterns.some((pattern) => pattern.test(url));
}
function sanitizeContainerName(name) {
  const sanitized = name.toLowerCase().replace(/[^a-z0-9_.-]/g, "-").replace(/^[^a-z0-9]+/, "").substring(0, 63);
  return sanitized || "container";
}
export {
  RESERVED_ENV_KEYS,
  generateCuid,
  generateId,
  isValidGitUrl,
  retry,
  sanitizeContainerName,
  sleep
};
